/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ItineraryInputs */

const en_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinerary`)
};

const es_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinerario`)
};

const fr_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinéraire`)
};

const de_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiseplan`)
};

const ja_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅程表`)
};

const zh_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行程安排`)
};

const ar_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسار الرحلة`)
};

const id_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana Perjalanan`)
};

const it_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinerario`)
};

const ru_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маршрут`)
};

const pt_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itinerário`)
};

const ko_val_itinerary = /** @type {(inputs: Val_ItineraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여행 일정`)
};

/**
* | output |
* | --- |
* | "Itinerary" |
*
* @param {Val_ItineraryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_itinerary = /** @type {((inputs?: Val_ItineraryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ItineraryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_itinerary(inputs)
	if (locale === "es") return es_val_itinerary(inputs)
	if (locale === "fr") return fr_val_itinerary(inputs)
	if (locale === "de") return de_val_itinerary(inputs)
	if (locale === "ja") return ja_val_itinerary(inputs)
	if (locale === "zh") return zh_val_itinerary(inputs)
	if (locale === "ar") return ar_val_itinerary(inputs)
	if (locale === "id") return id_val_itinerary(inputs)
	if (locale === "it") return it_val_itinerary(inputs)
	if (locale === "ru") return ru_val_itinerary(inputs)
	if (locale === "pt") return pt_val_itinerary(inputs)
	return ko_val_itinerary(inputs)
});